<template>
  <layout-main-inner title="合伙人">
    <!-- <el-button slot="action"
      type="primary"
      @click="create"
      size="small">新增内容</el-button> -->
    <layout-card-wrap hasHeaderSlot>
      <el-form
        slot="form"
        :inline="true"
        class="margin-botton-0">
        <el-form-item style="margin-bottom: 0">
          <el-radio-group
            v-model="config.status"
            @change="handleCurrentChange(1)">
            <el-radio-button :label="null">全部</el-radio-button>
            <el-radio-button :label="1">待审核</el-radio-button>
            <el-radio-button :label="2">审核通过</el-radio-button>
            <el-radio-button :label="9">审核未通过</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item style="margin-bottom: 0">
          <el-input
            v-model.trim="config.agentName"
            clearable=""
            placeholder="请输入合伙人姓名"></el-input>
        </el-form-item>
        <el-form-item style="margin-bottom: 0">
          <el-button
            type="primary"
            @click="handleCurrentChange(1)">查询</el-button>
        </el-form-item>
      </el-form>
      <el-table
        border
        :data="list">
        <el-table-column label="合伙人名称">
          <template slot-scope="{row}">
            <link-route
              v-if="row.status === 2"
              :link-to="`/wxapp-agent-detail?agentId=${row.agentId}&vendorId=${row.vendorId}`">{{ row.agentName }}</link-route>
            <div v-else>{{ row.agentName }}</div>
          </template>
        </el-table-column>
        <!-- <el-table-column label="关联会员">
          <template slot-scope="{row}">
            <link-route :link-to="`/memberdetail?userId=${row.userId}&vendorId=${userInfo.vendorId}`">{{ row.userName }}</link-route>
          </template>
        </el-table-column> -->
        <el-table-column
          label="手机号码"
          prop="agentPhone"
          width="150"></el-table-column>
        <!-- <el-table-column label="来源"
          width="100">
          <template slot-scope="{row}">
            <span>{{row.introduceType === 1 ? '邀请制' : '注册制'}}</span>
          </template>
        </el-table-column> -->
        <el-table-column
          label="合伙人类型"
          width="170px">
          <template slot-scope="{row}">
            <span v-if="row.status === 2">
              <span v-if="row.zsDealerId">经销商合伙人</span>
              <span v-else>普通合伙人</span>
            </span>
          </template>
        </el-table-column>
        <el-table-column
          label="加入时间"
          width="140px">
          <template slot-scope="{row}">
            {{ row.ackTime | dateformat() }}
          </template>
        </el-table-column>
        <el-table-column
          label="邀请人"
          width="100px">
          <template slot-scope="{row}">
            {{ row.inviterUserVO.userName }}
          </template>
        </el-table-column>
        <!-- <el-table-column
          label="推荐码"
          width="80"
          prop="referralCode"></el-table-column> -->
        <el-table-column
          label="状态"
          width="140">
          <template slot-scope="{row}">
            <el-tag
              v-if="row.status === 1"
              type="info">待审核</el-tag>
            <el-tag
              v-if="row.status === 2"
              type="success">审核通过</el-tag>
            <el-tag
              v-if="row.status === 9"
              type="danger">审核未通过</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="160">
          <template slot-scope="{row}">
            <el-button
              style="margin-right: 10px"
              type="danger"
              @click="deleteagent(row)">删除</el-button>
            <el-dropdown v-if="row.status === 1">
              <el-button type="warning">审核<i class="el-icon-arrow-down el-icon--right"></i></el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="auditPass1(row)">普通合伙人</el-dropdown-item>
                <el-dropdown-item @click.native="auditPass2(row)">经销商合伙人</el-dropdown-item>
                <el-dropdown-item @click.native="auditFail(row)">不通过</el-dropdown-item>
                <!-- <el-dropdown-item
                  v-if="row.status === 2"
                  @click.native="auditFail(row)">业绩设置</el-dropdown-item> -->
              </el-dropdown-menu>
            </el-dropdown>
            <!-- <el-button
              v-if="row.status === 2"
              type="info"
              @click.native="agentSet(row)">业绩设置</el-button> -->
            <el-dropdown v-if="row.status === 2">
              <el-button
                type="info">更多<i class="el-icon-arrow-down el-icon--right"></i></el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  @click.native="agentSet(row)">业绩设置</el-dropdown-item>
                <el-dropdown-item
                  v-if="row.zsDealerId"
                  @click.native="changeAgent(row)">切换经销商</el-dropdown-item>
                <el-dropdown-item
                  v-if="!row.zsDealerId"
                  @click.native="upAgent(row)">升级为经销商合伙人</el-dropdown-item>
                <el-dropdown-item
                  v-if="row.zsDealerId"
                  @click.native="downAgent(row)">降级为普通合伙人</el-dropdown-item>
                <!-- <el-dropdown-item
                  @click.native="deleteagent(row)">删除</el-dropdown-item> -->
                <el-dropdown-item @click.native="setagentinviter(row)">设置邀请人</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <!-- <el-button
              style="margin-left:10px"
              type="text"
              @click="deleteagent(row)">删除</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <template slot="footer">
        <pagination-new
          v-model="config"
          :total="total"
          :fetch="fetchList" />
      </template>
    </layout-card-wrap>
    <partner-audit-modal
      ref="modal"
      :callback="fetchList" />
    <jxs-select-modal ref="jxs" />
    <partner-modal ref="partner" />
    <staff-select-modal
      ref="staff"
      :callback="fetchList" />
  </layout-main-inner>
</template>
<script>
import { mapState } from 'vuex'
import JxsSelectModal from './jxs-select-modal.vue'
import PartnerModal from '../wxapp-set/busi/partner-modal.vue'
import PartnerAuditModal from './busi/partner-audit-modal.vue'
import StaffSelectModal from './staff-select-modal.vue'

export default {
  name: 'WxappAgentList',
  components: { PartnerAuditModal, PartnerModal, JxsSelectModal, StaffSelectModal },
  props: {},
  data() {
    return {
      loading: true,
      list: [],
      total: 0,
      config: {
        pageNum: 1,
        pageSize: 10,
        status: null,
        agentName: ''
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo
    })
  },
  activated() {
    this.fetchList()
  },
  mounted() {
    this.config.vendorId = this.userInfo.vendorId
    this.fetchList()
  },
  methods: {
    setagentinviter(row) {
      this.$refs.staff.fetch(row)
    },
    handleCurrentChange(cur) {
      this.config.pageNum = cur
      this.fetchList()
    },
    fetchList() {
      this.loading = true
      this.$store.dispatch('agent/getagents', {
        payload: {
          agentName: this.config.agentName,
          pageNum: this.config.pageNum,
          pageSize: this.config.pageSize,
          statusList: this.config.status === null ? null : [this.config.status]
        },
        success: res => {
          this.loading = false
          this.total = res.data.total
          this.list = res.data.records.map(i => {
            return {
              ...i,
              inviterUserVO: i.inviterUserVO || {}
            }
          })
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    agentSet(row) {
      console.log(row)
      this.$refs.partner.fetch(row)
    },
    auditFail(row) {
      this.$prompt('请输入审核不通过的原因', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /.+/,
        inputErrorMessage: '原因不能为空'
      }).then(({ value }) => {
        this.loading = true
        this.$store.dispatch('agent/auditagent', {
          payload: {
            agentId: row.agentId,
            vendorId: row.vendorId,
            pass: 0,
            reason: value
          },
          success: () => {
            this.loading = false
            this.fetchList()
          },
          fail: () => {
            this.loading = false
          }
        })
      })
    },
    auditPass1(row) {
      this.$confirm(`审核通过，${row.agentName}将成为普通合伙人, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        this.$store.dispatch('agent/auditagent', {
          payload: {
            agentId: row.agentId,
            vendorId: row.vendorId,
            pass: 1
          },
          success: () => {
            this.loading = false
            this.fetchList()
          },
          fail: () => {
            this.loading = false
          }
        })
      })
    },
    auditPass2(row) {
      this.$refs.jxs.fetch(row)
    },
    deleteagent(row) {
      this.$confirm('此操作将永久删除该合伙人, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        this.$store.dispatch('agent/deleteagent', {
          payload: {
            agentId: row.agentId,
            vendorId: row.vendorId
          },
          success: () => {
            this.loading = false
            this.fetchList()
          },
          fail: () => {
            this.loading = false
          }
        })
      })
    },
    upAgent(row) {
      // this.$refs.modal.fetch(row, 'up')
      this.$refs.jxs.fetch(row)
    },
    changeAgent(row) {
      // this.$refs.modal.fetch(row, 'up')
      this.$refs.jxs.fetch(row)
    },
    downAgent(row) {
      this.$confirm('此操作将使该合伙人降级为普通合伙人, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        this.$store.dispatch('agent/unbindzsdealer', {
          payload: {
            agentId: row.agentId,
            vendorId: row.vendorId
          },
          success: () => {
            this.loading = false
            this.fetchList()
          },
          fail: () => {
            this.loading = false
          }
        })
      })
    }
  }
}
</script>
